// src/features/tidsregistering/hooks/useRegistrationCodes.js
import { useState, useCallback } from 'react';
import { registrationCodesAPI } from '../services/registrationCodes';
import { useApi } from '../../../hooks/api/useApi';

export function useRegistrationCodes() {
  const [registrationCode, setRegistrationCode] = useState(null);
  const [registrationCodes, setRegistrationCodes] = useState([]);
  const [reasonCodeTypes, setReasonCodeTypes] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchRegistrationCode = useCallback(async (registrationCodeId) => {
    const result = await execute(() => registrationCodesAPI.getRegistrationCode(registrationCodeId));
    if (result.success) setRegistrationCode(result.data ?? null);
    return result;
  }, [execute]);

  const fetchForDepartment = useCallback(async () => {
    const result = await execute(() => registrationCodesAPI.listForDepartment());
    if (result.success) setRegistrationCodes(result.data?.registration_codes ?? []);
    return result;
  }, [execute]);

  const createRegistrationCode = useCallback(async (data) => {
    const result = await execute(() => registrationCodesAPI.createRegistrationCode(data));
    if (result.success) setRegistrationCode(result.data ?? null);
    return result;
  }, [execute]);

  const updateRegistrationCode = useCallback(async (registrationCodeId, data) => {
    const result = await execute(() => registrationCodesAPI.updateRegistrationCode(registrationCodeId, data));
    if (result.success) setRegistrationCode(result.data ?? null);
    return result;
  }, [execute]);

  const deleteRegistrationCode = useCallback(async (registrationCodeId) => {
    const result = await execute(() => registrationCodesAPI.deleteRegistrationCode(registrationCodeId));
    if (result.success) setRegistrationCode(null);
    return result;
  }, [execute]);

  const seedDefaultCodes = useCallback(async () => {
    return execute(() => registrationCodesAPI.seedDefaultCodes());
  }, [execute]);

  const createReasonCodeType = useCallback(async (data) => {
    return execute(() => registrationCodesAPI.createReasonCodeType(data));
  }, [execute]);

  const fetchReasonCodeTypes = useCallback(async () => {
    const result = await execute(() => registrationCodesAPI.listReasonCodeTypes());
    if (result.success) setReasonCodeTypes(result.data?.reason_code_types ?? []);
    return result;
  }, [execute]);

  return {
    registrationCode,
    registrationCodes,
    reasonCodeTypes,
    loading,
    error,
    clearError,
    fetchRegistrationCode,
    fetchForDepartment,
    createRegistrationCode,
    updateRegistrationCode,
    deleteRegistrationCode,
    seedDefaultCodes,
    createReasonCodeType,
    fetchReasonCodeTypes,
  };
}
